import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  Card,
} from "@mui/material";
import {
  useDeleteBlackListNumberMutation,
  useLazySearchBlackListNumberQuery,
  useSearchBlackListNumberQuery,
} from "../../store/services/blacklistApi";
import { toast } from "react-toastify";

const SearchBlackList = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [submit, setSubmit] = useState(false);
  const [results, setResults] = useState([]);

  const [deleteBlackListNumber] = useDeleteBlackListNumberMutation();

  const [
    searchBlackListNumber,
    { data: searchResult, error: apiError, isLoading },
  ] = useLazySearchBlackListNumberQuery();

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      toast.error("Please enter a phone number");
      setError("Please enter a phone number");
      return;
    }

    try {
      const res = await searchBlackListNumber(phoneNumber).unwrap();

      if (res?.status && res?.data) {
        setResults([res.data]);
        setError("");
      } else {
        setResults([]);
        setError("Phone number not found");
        toast.error("Phone number not found");
      }
    } catch (err) {
      setResults([]);
      setError("Phone number not found");
      toast.error("Phone number not found");
    }
  };

  const handleDelete = async (phNo) => {
    try {
      const response = await deleteBlackListNumber({
        phone_numbers: [phNo],
      }).unwrap();
      if (response.status) {
        toast.success("Phone number removed from blacklist.");

        setResults((prev) => prev.filter((item) => item.phno !== phNo));

        setPhoneNumber("");
        setError("");
      } else {
        toast.error(response.message || "Error deleting phone number.");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Error deleting phone number.");
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "white",
        boxShadow: 3,
        borderRadius: 2,
        width: 400,
        maxWidth: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontSize: "0.75rem",
          fontWeight: 600,
        }}
      >
        Search Blacklist
      </Typography>

      <form onSubmit={handleSearch}>
        <TextField
          label="Phone Number"
          fullWidth
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          variant="outlined"
          size="small"
          sx={{
            mb: 2,
            "& .MuiInputBase-input": { fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isLoading}
          fullWidth
          size="small"
          sx={{ fontSize: "0.7rem", textTransform: "none" }}
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Search"
          )}
        </Button>
      </form>
      {results.length > 0 &&
        results.map((item) => (
          <Card
            key={item.phno}
            sx={{
              mt: 2,
              p: 1.5,
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              boxShadow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: "0.75rem", color: "text.secondary" }}
            >
              <strong>Phone Number:</strong> {item.phno}
            </Typography>

            <Button
              size="small"
              color="error"
              variant="outlined"
              sx={{ fontSize: "0.7rem", textTransform: "none" }}
              onClick={() => handleDelete(item.phno)}
            >
              Delete
            </Button>
          </Card>
        ))}

    </Box>
  );
};

export default SearchBlackList;
